import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
const SuccessModal = ({ open, onClose }) => {
  const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText("#3653ff"),
    backgroundColor: "#003cde",
    marginLeft: "5%",
    "&:hover": {
      backgroundColor: "#003cde",
      color: "#fff",
    },
  }));

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Update Successful</DialogTitle>
      <DialogContent>
        <DialogContentText>
          The user information was successfully updated!!!
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <ColorButton variant="contained" onClick={onClose} className="add-user">
          Close
        </ColorButton>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessModal;
